
























import Vue from "vue";
import { AxiosResponse } from "axios";
import { formatDate, toHHMMSS } from "@/lib/utils";

export default Vue.extend({
  name: "EventDetails",
  props: {
    name: String,
    timeRangeQuery: Object,
  },
  data: () => {
    return {
      events: [],
      fields: [
        {
          key: "timestamp",
          label: "Start",
        },
        {
          key: "duration",
          formatter: toHHMMSS,
        },
        { key: "successmark", label: "Status" },
      ],
      loading: true,
    };
  },
  created() {
    this.loadData();
  },
  watch: {
    timeRangeQuery() {
      this.loadData();
    },
  },
  methods: {
    loadData() {
      this.loading = true;
      this.$store.state.api_client
        .get("/live/events/" + this.name, {
          params: this.timeRangeQuery,
        })
        .then((response: AxiosResponse) => {
          this.events = response.data.events.slice().reverse();
          this.loading = false;
        })
        .catch((error: Error) => {
          this.loading = false;
          console.log(error);
        });
    },
    formatDate,
  },
});
